import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { Divider, List } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { StandardRoutes } from "@src/components/Utils/routes";

interface StoreManagementSectionProps {
  drawerOpen: boolean;
}

export const StoreManagementSection = ({
  drawerOpen,
}: StoreManagementSectionProps) => {
  const viewNewAnalytics = useConfiguration("view_analytics");

  return (
    <>
      <SectionHeader title="Store management" drawerOpen={drawerOpen} />

      <List sx={{ px: drawerOpen ? 2 : 4, paddingTop: drawerOpen ? 0 : 2 }}>
        {viewNewAnalytics?.value && (
          <IgListItemLink
            drawerOpen={drawerOpen}
            Route={StandardRoutes().eventsManager}
            hasAccess={true}
            exact={true}
          />
        )}
        <IgListItemLink
          hasAccess={true}
          drawerOpen={drawerOpen}
          Route={StandardRoutes().widgetLibrary}
        />
        <IgListItemLink
          hasAccess={true}
          drawerOpen={drawerOpen}
          Route={StandardRoutes().integrations}
        />
      </List>
    </>
  );
};
